import axios from 'axios';
import * as constants from "../Constatnts";
import { handleApiError } from '../CommonFunctions';

export function saveFeedback(key, data) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key && key.trim() !== "") {
        response = await axios.put(
          `${constants.API_URL}/feedback/${key}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        response = await axios.post(
          `${constants.API_URL}/feedback`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

        return response.data;
    } catch (error) {
      console.error("API Error:", error);
      handleApiError(error);
      return null;
    }
  };
}
export function deleteFeedback(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        `${constants.API_URL}/feedback/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

     

      return response.data;

    } catch (error) {
      console.error("Error deleting bom:", error);
      throw error;
    }
  };
}

export function getFeedbacks() {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/feedback`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      return response.data;

    } catch (error) {
      console.error("Error deleting bom:", error);
      throw error;
    }
  };
}

export function getFeedbackById(id) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/feedback/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      return response.data.data || {};

    } catch (error) {
      console.error("Error deleting bom:", error);
      throw error;
    }
  };
}


export function getFeedbackResponsesByLinkId(id) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/feedback/response/link/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      return response.data || {};

    } catch (error) {
      console.error("Error feedback response:", error);
      throw error;
    }
  };
}
export function getFeedbackByTemplateId(id) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/feedback/template/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      return response.data || {};

    } catch (error) {
      console.error("Error deleting bom:", error);
      throw error;
    }
  };
}



export function saveFeedbackLink(key, data) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key && key.trim() !== "") {
        response = await axios.put(
          `${constants.API_URL}/feedback/link/${key}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        response = await axios.post(
          `${constants.API_URL}/feedback/link`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

        return response.data;
    } catch (error) {
      console.error("API Error:", error);
      handleApiError(error);
      return null;
    }
  };
}
export function deleteFeedbackLink(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        `${constants.API_URL}/feedback/link/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

     

      return response.data;

    } catch (error) {
      console.error("Error deleting bom:", error);
      throw error;
    }
  };
}

export function getFeedbackLinks(whitelabelcode) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/feedback/link?WhiteLabelCode=${encodeURIComponent(whitelabelcode)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      return response.data;

    } catch (error) {
      console.error("Error deleting bom:", error);
      throw error;
    }
  };
}

export function saveFeedbackResponse( data) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

    
        response = await axios.post(
          `${constants.API_URL}/feedback/response`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      

        return response.data;
    } catch (error) {
      console.error("API Error:", error);
      handleApiError(error);
      return null;
    }
  };
}